export const NEWSFEED = 'NEWSFEED'